import '@babel/polyfill';
import '../biotrust/optin';
import '../biotrust/trackers';
import '../biotrust/lockedInLanderCheckoutLinks';
import '../biotrust/vipSessionStorage';
import '../biotrust/utm_phone';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/include/ls.include';
import 'lazysizes/plugins/progressive/ls.progressive';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import Player from '@vimeo/player';
import 'bootstrap/js/modal';
import '../../styles/layout/webflow.scss';
window.Vimeo = {
  Player: Player
};